/**
 * `memberships` — qui fait quoi où (base plateforme, 4.1 et 5).
 */
import { z } from 'zod';
import { droitsFinsSchema, porteeSchema, roleSchema } from '../permissions/roles.js';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const ETATS_MEMBRE = ['actif', 'suspendu', 'retire'];
export const etatMembreSchema = z.enum(ETATS_MEMBRE);
export const membershipSchema = withAudit(z.object({
    _id: idSchema,
    compteId: idSchema,
    portee: porteeSchema,
    galerieId: idSchema.optional(),
    groupeId: idSchema.optional(),
    role: roleSchema,
    droits: droitsFinsSchema,
    etat: etatMembreSchema.default('actif'),
})).refine((membre) => (membre.portee === 'galerie' && membre.galerieId !== undefined) ||
    (membre.portee === 'groupe' && membre.groupeId !== undefined) ||
    membre.portee === 'console', { error: 'Un rattachement de galerie ou de groupe est attendu selon la portée.' });
/** Le même document, sans le contrôle croisé, pour composer les entrées d'API. */
export const membershipDocumentSchema = withAudit(z.object({
    _id: idSchema,
    compteId: idSchema,
    portee: porteeSchema,
    galerieId: idSchema.optional(),
    groupeId: idSchema.optional(),
    role: roleSchema,
    droits: droitsFinsSchema,
    etat: etatMembreSchema.default('actif'),
}));
export const membershipCreationSchema = membershipDocumentSchema.omit(CHAMPS_DOCUMENT);
export const membershipMiseAJourSchema = membershipCreationSchema
    .omit({ compteId: true, portee: true })
    .partial();
//# sourceMappingURL=memberships.js.map